import { render, staticRenderFns } from "./mainFormDocuments.vue?vue&type=template&id=cae7d012&"
import script from "./mainFormDocuments.vue?vue&type=script&lang=js&"
export * from "./mainFormDocuments.vue?vue&type=script&lang=js&"
import style0 from "./mainFormDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports